import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class OpenModalService {
  constructor(private readonly modalService: NgbModal) {
  }

  openDialog(content: any, options?: { modal?: NgbModalOptions; data?: any }): NgbModalRef {
    const modal = this.modalService.open(content, options?.modal);
    if (options?.data) {
      this.pushDataToModal(options.data, modal);
    }
    return modal;
  }

  private pushDataToModal(data: any, modal: NgbModalRef) {
    Object.keys(data).forEach(key => {
      modal.componentInstance[key] = data[key];
    });
  }
}


